import React, { createElement } from 'react';
import Styles from './index.module.scss';
import withHover from '@ifeng/lowcode_tool/src/hoc/withHover'

export interface ImageLink_Props {
    nodeId?: string;
    style: object;
    image: string;
    url: string;
    isBlock: boolean;
    width: number;
    height: number;
    objectFit: any;
}

const ImageLink: React.FC<ImageLink_Props> = (props) => {
    const { nodeId, style, image, url, width, isBlock, height, objectFit } = props;

    return url ? (
        <a
            id={nodeId}
            href={url}
            target="_blank"
            className={Styles.a}
            style={{ display: 'inline-block', lineHeight: 0, width: '100%' }}
        >
            <img
                src={image}
                className={Styles.img}
                style={{ width: isBlock ? '100%' : width, height, objectFit, ...style }}
                alt=""
            />
        </a>
    ) : (
        <img
            id={nodeId}
            src={image}
            className={Styles.img}
            style={{ width: isBlock ? '100%' : width, height, objectFit, ...style }}
            alt=""
        />
    );
};

export default withHover(ImageLink);
